import { useAppDispatch, useAppSelector } from "state/hooks.ts";
import { getBankAccountsState } from "state/slices/bank-accounts-slice.ts";
import { 
  getDepositFundsModalState, 
  setSelectedPaymentMethod,
  hideDepositModalV2
} from "state/slices/deposit-funds-modal-v2-slice.ts";
import { BankAccount } from "interfaces/commerce/bank-account.ts";
import BankAccountSelector from "./bank-account-selector.tsx";
import { sparketLightGray } from "utils/constants.ts";

const DepositFundsModalAchPaymentBlock = () => {
  const dispatch = useAppDispatch();
  const bankAccountsState = useAppSelector(getBankAccountsState);
  const modalState = useAppSelector(getDepositFundsModalState);

  // Get the selected ACH account ID from the modal state
  const selectedAccountId = modalState.selectedPaymentMethod?.type === 'ACH' 
    ? modalState.selectedPaymentMethod.bankAccountId 
    : undefined;

  // Find the selected bank account object
  const selectedMethod = selectedAccountId 
    ? bankAccountsState.accounts.find(account => account.id === selectedAccountId)
    : undefined;

  const handleMethodSelect = (method: BankAccount) => {
    dispatch(setSelectedPaymentMethod({
      type: 'ACH',
      bankAccountId: method.id,
      provider: method.provider
    }));
  };

  const handleClose = () => {
    dispatch(hideDepositModalV2());
  };

  return (
    <div>
      <BankAccountSelector
        provider={bankAccountsState.depositProvider}
        selectedMethod={selectedMethod}
        onMethodSelect={handleMethodSelect}
        onClose={handleClose}
        returnUrl="/profile?openDepositModal=true"
      />
    </div>
  );
};

export default DepositFundsModalAchPaymentBlock; 